import React from 'react';
import { MapPin, Navigation, Info, X } from 'lucide-react';

const PlanningIndicator = ({ planningMode, startLocation, isVisible, setIsVisible }) => {
  if (!planningMode || !isVisible) return null;

  return (
    <div className="absolute top-16 left-1/2 transform -translate-x-1/2 z-50 animate-bounce-subtle">
      <div className="bg-blue-600 text-white rounded-lg shadow-lg overflow-hidden max-w-xs w-64">
        <div className="flex items-center bg-blue-700 p-2">
          <Info size={16} className="mr-2" />
          <span className="font-medium text-sm">Planning Mode</span>
          
          {/* Close Button */}
          <button 
            onClick={() => setIsVisible(false)} 
            className="ml-auto text-white p-1"
          >
            <X size={16} />
          </button>
        </div>
        
        <div className="p-3 flex items-center">
          {startLocation ? (
            <>
              <Navigation size={20} className="mr-2 text-blue-300" />
              <p className="text-sm">Now click to set your destination</p>
            </>
          ) : (
            <>
              <MapPin size={20} className="mr-2 text-blue-300" />
              <p className="text-sm">Click on the map to set your starting point</p>
            </>
          )}
        </div>
        
        <div className="h-1 w-full bg-blue-700">
          <div 
            className="h-full bg-blue-300 animate-progress" 
            style={{ 
              animation: startLocation 
                ? 'progress 5s linear infinite' 
                : 'progress 10s ease-in-out infinite' 
            }}
          ></div>
        </div>
      </div>
      
      {/* Custom animations */}
      <style jsx global>{`
        @keyframes bounce-subtle {
          0%, 100% {
            transform: translateY(0) translateX(-50%);
          }
          50% {
            transform: translateY(-5px) translateX(-50%);
          }
        }
        
        @keyframes progress {
          0% { width: 5%; }
          50% { width: 95%; }
          100% { width: 5%; }
        }
        
        .animate-bounce-subtle {
          animation: bounce-subtle 3s ease-in-out infinite;
        }
        
        .animate-progress {
          animation: progress 5s linear infinite;
        }
      `}</style>
    </div>
  );
};

export default PlanningIndicator;
